"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const List = styled_1.default.ul({
    borderRadius: '6px',
    boxShadow: '0 10px 24px 0 rgba(155,165,177,0.2)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    listStyleType: 'none',
    borderWidth: 1,
    borderStyle: 'solid',
    margin: 0,
    padding: 17,
    width: 'fit-content',
    boxSizing: 'border-box'
}, ({ theme: { palette } }) => ({
    borderColor: palette.colors.solitude2,
    color: palette.colors.coolGrey
}));
exports.default = List;
//# sourceMappingURL=List.js.map